import type { IResultstash, JsonQuery } from "@mne-core/api";
import { QueryController, createCsrfToken, createHeaders, fetchJsonQuery } from "@mne-core/api";

import type { IAuthorizationData } from "../@types";
import AuthenticationURI from "./AuthenticationURIBuilder";

export interface IAuthorizeWebauthnCriteria {
  operation: string;
  context?: { [key: string]: string };
  nextURI: string;
  webauthnKeyID: string;
  challengeID: string;
  authenticatorData: string;
  clientData: string;
  signature: string;
}

export interface IAuthorizeWebauthnOpts extends RequestInit {
  apiUrl: string;
  apiKey?: string;
  sessionKey: string;
  ctrl?: QueryController;
}

export const createRequest = (criteria: IAuthorizeWebauthnCriteria, opts: IAuthorizeWebauthnOpts): Request => {
  const { apiUrl, apiKey, sessionKey, ...restOpts } = opts;
  const uri = new AuthenticationURI().setApiUrl(apiUrl).setSegment(["signature", "webauthn", "authorize"]).build();

  const headers = createHeaders({
    "ARGUS-API-KEY": apiKey,
    Accept: "application/json",
    "Content-type": "application/json",
    "ARGUS-CSRF-Token": !apiKey ? createCsrfToken(sessionKey, String(uri)) : false,
  });

  let localRequestOpts: RequestInit = {
    body: JSON.stringify(criteria),
    headers,
    method: "POST",
    mode: "cors",
  };

  if (!apiKey) {
    /**
     * Only add cookies if no apikey is provided
     */
    localRequestOpts = {
      ...localRequestOpts,
      credentials: "include",
    };
  }

  return new Request(String(uri), {
    ...localRequestOpts,
    ...restOpts,
  });
};

async function authorizeWebauthn(
  criteria: IAuthorizeWebauthnCriteria,
  opts: IAuthorizeWebauthnOpts,
): Promise<JsonQuery<IResultstash<IAuthorizationData>>> {
  return await fetchJsonQuery<IResultstash<IAuthorizationData>>(createRequest(criteria, opts), {
    ctrl: opts.ctrl || new QueryController(),
  });
}

export default authorizeWebauthn;
